var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChoosedRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3763 16.7666L32.9445 14.9848V10.706L30.065 10.7063V12.8761L26.6676 10.3862C25.9944 9.89289 25.078 9.89981 24.4124 10.4031L15.9466 16.8012C15.3294 17.2675 15.2184 18.1555 15.7102 18.7607C16.1792 19.3374 17.0329 19.4171 17.6258 18.9689L18.1844 18.5466V25.6763C18.1844 26.5941 18.9284 27.3386 19.8468 27.3386H31.5115C32.4293 27.3386 33.1738 26.5947 33.1738 25.6763V18.5516L33.7851 18.9999C34.0291 19.1791 34.3133 19.2655 34.5943 19.2655C35.01 19.2655 35.4198 19.0769 35.6887 18.721C36.1493 18.1103 35.9937 17.2196 35.3764 16.7666L35.3763 16.7666ZM23.6 24.7163V18.4241H27.757V24.7163H23.6Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6802 3.33352C17.2183 3.33352 10.3359 10.2175 10.3359 18.6778C10.3359 25.9727 15.4902 32.267 22.619 33.7147L24.6318 38.786C24.8671 39.2252 25.3171 39.4947 25.8132 39.4947H25.8448C26.3528 39.4827 26.805 39.1909 27.0375 38.6981L28.8003 33.703C35.8964 32.2326 41.0264 25.9451 41.0264 18.6776C41.0246 10.2173 34.1416 3.33337 25.6799 3.33337L25.6802 3.33352ZM25.6802 5.73916C32.8148 5.73916 38.6194 11.5435 38.6194 18.6791C38.6194 25.8143 32.8151 31.6184 25.6802 31.6184C18.5453 31.6184 12.7402 25.8141 12.7402 18.6784C12.7402 11.5432 18.5454 5.73916 25.6802 5.73916Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9274 42.9578C37.9274 41.8303 32.4437 40.9167 25.6782 40.9167H25.6727C18.9109 40.9173 13.4297 41.8312 13.4297 42.9584C13.4297 44.0859 18.9133 45.0001 25.6789 45.0001C32.4444 45.0001 37.9274 44.085 37.9274 42.9578Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoosedRoute);
export default __webpack_public_path__ + "static/media/ChoosedRoute.aad579863315249645cb3962cc92884f.svg";
export { ForwardRef as ReactComponent };